
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[domain]/[widgetSlug]",
      function () {
        return require("private-next-pages/[domain]/[widgetSlug]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[domain]/[widgetSlug]"])
      });
    }
  